export function iso8601Duration(milliseconds: number) {
    const dt = new Date(milliseconds);
    const units: Array<[string, number | null]> = [
        ["Y", dt.getUTCFullYear() - 1970],
        ["M", dt.getUTCMonth()],
        ["D", dt.getUTCDate() - 1],
        ["T", null],
        ["H", dt.getUTCHours()],
        ["M", dt.getUTCMinutes()],
        ["S", dt.getUTCSeconds()],
    ];

    let duration = units.reduce((accumulator, [key, value]) => {
        if (value) {
            return `${accumulator}${value}${key}`;
        } else if (key === "T") {
            return `${accumulator}${key}`;
        }

        return accumulator;
    }, "");

    duration = duration.endsWith("T") ? duration.slice(0, -1) : duration;

    return duration ? `P${duration}` : null;
}

/**
 * @example convertMillisecondsToMinutesAndSecondsString(100000) --> "1 Minutes 40 Seconds"
 **/
export const convertMillisecondsToMinutesAndSecondsString = (
    timeInMs?: number
): string => {
    if (!timeInMs) {
        return "0:00";
    }

    const timeInSeconds = timeInMs / 1000;

    const mins = Math.floor(timeInSeconds / 60);
    const secs = Math.floor(timeInSeconds % 60);

    return `${mins}:${`${secs}`.padStart(2, "0")}`;
};
